import { render, staticRenderFns } from "./iot_add_field.vue?vue&type=template&id=d2c85d50&"
import script from "./iot_add_field.vue?vue&type=script&lang=js&"
export * from "./iot_add_field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports